import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Box, Flex, Text, Button } from "rebass/styled-components";
import Container from "./UI/Container";
import { motion, AnimatePresence } from "framer-motion";
import Markdown from "./UI/Markdown";
// in your cookie banner
import { useLocation } from "@reach/router"; // this helps tracking the location
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";

function getCookie(cname, defaultValue) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return defaultValue;
}
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const CookiesBanner = ({ siteinfos, bypass }) => {
  bypass = bypass || false;
  const location = useLocation();
  const [onboarding, setOnboarding] = useState(false);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setOnboarding(getCookie("onboarding", false));
      setLoaded(true);
      if (getCookie("onboarding", false)) {
        PageView();
      }
    }
  }, []);
  const cookieAccept = () => {
    // action accept cookies
    setCookie("onboarding", !onboarding, 365);
    setOnboarding(!onboarding);
    PageView();
  };

  const PageView = () => {
    initializeAndTrack(location);
  };
  if (bypass) {
    return <></>;
  }
  const hasGA = siteinfos.gacode ? true : false;
  return (
    <Box variant="cookiesBanner">
      <AnimatePresence initial={false}>
        {!onboarding && loaded && (siteinfos.gacode || siteinfos.facebookPixel) && (
          <motion.div
            positionTransition
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50, transition: { duration: 0.2 } }}
          >
            <Box bg="white">
              <Container>
                <Flex alignItems="center" flexDirection={["column","row"]} paddingBottom={[2,0]}>
                  <Markdown pr={2}>{siteinfos.rgpdBanner}</Markdown>
                  <Box
                    pl={5}
                    sx={{
                      flex: 1,
                      minWidth: "auto"
                    }}
                  >
                    <Button  onClick={() => cookieAccept()}>J&#39;accepte</Button>
                  </Box>
                </Flex>
              </Container>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

CookiesBanner.propTypes = {
  bypass: PropTypes.bool,
  siteinfos: PropTypes.shape({
    facebookPixel: PropTypes.any,
    gacode: PropTypes.any,
    rgpdBanner: PropTypes.any,
    gaviagtm: PropTypes.bool
  })
};

export default CookiesBanner;
